module.exports = __webpack_public_path__ + "static/img/Thin.3a50804.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sesson/Thin.png
// module id = J5za
// module chunks = 1